//import view components

//home
import Landing from "../../pages/landing/landing";
import DomesticFlightSearch from "../../pages/flight/domestic/domestic-flight-search";
import IntFlightSearch from "../../pages/flight/international/int-flight-search";
import HotelSearch from "../../pages/hotel/hotel-search";
import Login from "../../pages/login/login";

//flight
import Flight from "../../pages/flight/flight";
import DomesticFlight from "../../pages/flight/domestic/domestic-flight";
import IntFlight from "../../pages/flight/international/int-flight";
import RefundRules from "../../pages/flight/domestic/refund-rules";
import FlightAvailabilityNotification from "../../pages/availability/notification/flight-availability-notification";

//hotel
import Hotel from "../../pages/hotel/hotel";
import HotelPage from "../../pages/hotel/hotel-page";

//itinerary
import SearchForm from "../../components/view/landing/search-form";

//tour
import Tour from "../../pages/tour/tour";
import TourInformation from "../../pages/tour-information/tour-information";
import MedicalTourism from "../../pages/medical-tourism/medical-tourism";
import MedicalTourismResult from "../../pages/medical-tourism-result/medical-tourism-result";

//wizard
import Favorites from "../../pages/favorites/favorites";
import Itinerary from "../../pages/itinerary/itinerary";

//others
import Cart from "../../pages/cart/cart";
import FlightPassengers from "../../pages/passengers/flight-passengers";
import IntFlightPassengers from "../../pages/passengers/int-flight-passengers";
import HotelPassengers from "../../pages/passengers/hotel-passengers";
import IntHotelPassengers from "../../pages/passengers/int-hotel-passengers";
import ConfirmInformation from "../../pages/confirm-information/confirmation";
import AboutUs from "../../pages/about-us/about-us";
import ContactUs from "../../pages/contact-us/contact-us";
import Location from "../../pages/location/location";
import Rules from "../../pages/rules/rules";
import Miras from "../../components/common/footer/miras";
import PaymentResult from "../../pages/payment-result/payment-result";
import SubmitComplaints from "../../pages/submit-complaints/submit-complaints";

//user panel
import UserPanel from "../../pages/user-panel/user-panel";
import UserAccount from "../../pages/user-panel/user-account/user-account";
import Orders from "../../pages/user-panel/orders/orders";
import MyItinerary from "../../pages/user-panel/my-itinerary/my-itinerary";
import ViewItinerary from "../../components/view/user-panel/my-itinerary/view-itinerary";
import MyTours from "../../components/view/user-panel/my-tours/my-tours";
import Passenger from "../../pages/user-panel/passenger/passenger";
import Wallet from "../../pages/user-panel/wallet/wallet";
import UserFavorites from "../../pages/user-panel/user-favorites/user-favorites";
import Support from "../../pages/user-panel/support/support";
import DeleteAccount from "../../pages/user-panel/delete-account/delete-account";

//admin panel
import AdminPanel from "../../pages/admin-panel/admin-panel";
import LocationsManagment from "../../pages/admin-panel/locations-managment/locations-managment";
import Information from "../../pages/admin-panel/information/information";
import LocationAdd from "../../components/view/admin-panel/locations-managment/location-add/location-add";
import LocationPoint from "../../components/view/admin-panel/locations-managment/location-point/location-point";

import BusinessCard from "../../pages/business-card/business-card";
import { Playground } from "../../pages/playground/playground";

//interfaces
import PublicRouteGuard from "../guards/PublicRouteGuard";
import ItineraryRouteGuard from "../guards/ItineraryRouteGuard";
import ItineraryLayout from "../../constants/layouts/itinerary-layout";

//routes
import {
    getLandingPageUrl,
    getRefundRulesPageUrl,
    getItineraryLayoutUrl,
    getFavoritesPageUrl,
    getFlightWPageUrl,
    getIntFlightWPageUrl,
    getHotelWPageUrl,
    getItineraryPageUrl,
    getCartPageUrl,
    getFlightPassengersPageUrl,
    getHotelPassengersPageUrl,
    getIntHotelPassengersPageUrl,
    getConfirmInformationPageUrl,
    getPaymentResultPageUrl,
    getTourPageUrl,
    getTourInformationPageUrl,
    getLocationPageUrl,
    getAboutUsPageUrl,
    getContactUsPageUrl,
    getSubmitComplaintsPageUrl,
    getRulesPageUrl,
    getMirasPageUrl,
    getUserPanelPageUrl,
    getUserAccountPageUrl,
    getOrdersPageUrl,
    getMyItineraryPageUrl,
    getMyItineraryViewPageUrl,
    getPassengerPageUrl,
    getWalletPageUrl,
    getUserFavoritesPageUrl,
    getSupportPageUrl,
    getDeleteAccountPageUrl,
    getAdminPanelPageUrl,
    getLocationsManagmentPageUrl,
    getInformationPageUrl,
    getLocationAddPageUrl,
    getLocationPointPageUrl,
    getBusinessCardPageUrl,
    getPlaygroundPageUrl,
    getIntFlightPassengersPageUrl,
    getMedicalTourismPageUrl,
    getMedicalTourismResultPageUrl,
    getMyToursPageUrl,
    getFlightSearchPageUrl,
    getHotelSearchPageUrl,
    getDomesticFlightSearchPageUrl,
    getIntFlightSearchPageUrl,
    getDomesticHotelSearchPageUrl,
    getIntHotelSearchPageUrl,
    getDomesticFlightPageUrl,
    getIntFlightPageUrl,
    getHotelPageUrl,
    getLoginPageUrl,
    getDefaultUrl,
    getEventPageUrl,
    getFriendsIntroductionPageUrl,
    getAccommodationSearchPageUrl,
    getFlightAvailabilityPageUrl,
    getSmartReservationPageUrl,
    getFlightAutomaticReservationPageUrl,
    getFlightAutomaticReservationConfirmPageUrl,
    getStudyAbroadPageUrl,
    getRedirectQRCodePageUrl,
    getWorkImmigrationPageUrl,
    getBusPageUrl,
    getBusSearchPageUrl,
    getBusPassengersPageUrl,
} from "../routingConstants/AppUrls";
import EventRegistration from "../../pages/event/Event";
import PrivateRouteGuard from "../guards/PrivateRouteGuard";
import FriendsIntroduction from "../../pages/user-panel/friends-introduction/friends-introduction";
import AccommodationSearch from "../../pages/hotel/accomodation-search";
import SmartReservation from "../../pages/user-panel/smart-reservation/smart-reservation";
import FlightAutomaticReservation from "../../pages/availability/reserve/flight-automatic-reservation";
import FlightAutomaticReservationConfirm from "../../pages/availability/reserve/flight-automatic-reservation-confirm";
import StudyAbroad from "../../pages/study-abroad/study-abroad";
import { QRCode } from "../../pages/QR-code/QR-code";
import WorkImmigration from "../../pages/work-immigration/work-immigration";
import BusSearchForm from "../../pages/bus/bus-search-form";
import BusPage from "../../pages/bus/bus";
import BusPassengers from "../../pages/passengers/bus-passengers";

const flightChildren = [
    {
        element: (
            <PublicRouteGuard>
                <DomesticFlightSearch />
            </PublicRouteGuard>
        ),
        path: locale => getDomesticFlightSearchPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <IntFlightSearch />
            </PublicRouteGuard>
        ),
        path: locale => getIntFlightSearchPageUrl(locale),
    },
];

const hotelChildren = [
    {
        element: (
            <PublicRouteGuard>
                <HotelSearch isHotelInternational={false} type="hotel" />
            </PublicRouteGuard>
        ),
        path: locale => getDomesticHotelSearchPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <HotelSearch isHotelInternational={true} type="hotel" />
            </PublicRouteGuard>
        ),
        path: locale => getIntHotelSearchPageUrl(locale),
    },
];

const landingChildren = [
    {
        element: (
            <PublicRouteGuard>
                <Flight />
            </PublicRouteGuard>
        ),
        path: locale => getFlightSearchPageUrl(locale),
        children: flightChildren,
    },
    {
        element: (
            <PublicRouteGuard>
                <Hotel />
            </PublicRouteGuard>
        ),
        path: locale => getHotelSearchPageUrl(locale),
        children: hotelChildren,
    },
    {
        element: (
            <PublicRouteGuard>
                <SearchForm />
            </PublicRouteGuard>
        ),
        path: locale => getItineraryLayoutUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <AccommodationSearch isHotelInternational={false} type="accommodation" />
            </PublicRouteGuard>
        ),
        path: locale => getAccommodationSearchPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <BusSearchForm />
            </PublicRouteGuard>
        ),
        path: locale => getBusSearchPageUrl(locale),
    },
];

const userPanelChildren = [
    {
        element: (
            <PublicRouteGuard>
                <UserAccount />
            </PublicRouteGuard>
        ),
        path: locale => getUserAccountPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Orders />
            </PublicRouteGuard>
        ),
        path: locale => getOrdersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <FriendsIntroduction />
            </PublicRouteGuard>
        ),
        path: locale => getFriendsIntroductionPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <MyItinerary />
            </PublicRouteGuard>
        ),
        path: locale => getMyItineraryPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <MyTours />
            </PublicRouteGuard>
        ),
        path: locale => getMyToursPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Passenger />
            </PublicRouteGuard>
        ),
        path: locale => getPassengerPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Wallet />
            </PublicRouteGuard>
        ),
        path: locale => getWalletPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <SmartReservation />
            </PublicRouteGuard>
        ),
        path: locale => getSmartReservationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <UserFavorites />
            </PublicRouteGuard>
        ),
        path: locale => getUserFavoritesPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Support />
            </PublicRouteGuard>
        ),
        path: locale => getSupportPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <DeleteAccount />
            </PublicRouteGuard>
        ),
        path: locale => getDeleteAccountPageUrl(locale),
    },
];

const adminChildren = [
    {
        element: (
            <PublicRouteGuard>
                <LocationsManagment />
            </PublicRouteGuard>
        ),
        path: locale => getLocationsManagmentPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <LocationAdd />
            </PublicRouteGuard>
        ),
        path: locale => getLocationAddPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <LocationPoint />
            </PublicRouteGuard>
        ),
        path: locale => getLocationPointPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Information />
            </PublicRouteGuard>
        ),
        path: locale => getInformationPageUrl(locale),
    },
];

const ItineraryChildren = [
    {
        element: (
            <ItineraryRouteGuard>
                <Favorites />
            </ItineraryRouteGuard>
        ),
        path: locale => getFavoritesPageUrl(locale),
    },
    {
        element: (
            <ItineraryRouteGuard>
                <DomesticFlight />
            </ItineraryRouteGuard>
        ),
        path: locale => getFlightWPageUrl(locale),
    },
    {
        element: (
            <ItineraryRouteGuard>
                <IntFlight />
            </ItineraryRouteGuard>
        ),
        path: locale => getIntFlightWPageUrl(locale),
    },
    {
        element: (
            <ItineraryRouteGuard>
                <HotelPage />
            </ItineraryRouteGuard>
        ),
        path: locale => getHotelWPageUrl(locale),
    },
    {
        element: (
            <ItineraryRouteGuard>
                <Itinerary />
            </ItineraryRouteGuard>
        ),
        path: locale => getItineraryPageUrl(locale),
    },
];

const publicRoutes = [
    {
        element: (
            <PublicRouteGuard>
                <Landing />
            </PublicRouteGuard>
        ),
        path: locale => getLandingPageUrl(locale),
        children: landingChildren,
    },
    {
        element: (
            <PublicRouteGuard>
                <Login />
            </PublicRouteGuard>
        ),
        path: locale => getLoginPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <ItineraryLayout />
            </PublicRouteGuard>
        ),
        path: locale => getItineraryLayoutUrl(locale),
        children: ItineraryChildren,
    },
    {
        element: (
            <PublicRouteGuard>
                <DomesticFlight />
            </PublicRouteGuard>
        ),
        path: locale => getDomesticFlightPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <IntFlight />
            </PublicRouteGuard>
        ),
        path: locale => getIntFlightPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <HotelPage />
            </PublicRouteGuard>
        ),
        path: locale => getHotelPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Tour />
            </PublicRouteGuard>
        ),
        path: locale => getTourPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <TourInformation />
            </PublicRouteGuard>
        ),
        path: locale => getTourInformationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <BusPage />
            </PublicRouteGuard>
        ),
        path: locale => getBusPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <MedicalTourism />
            </PublicRouteGuard>
        ),
        path: locale => getMedicalTourismPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <MedicalTourismResult />
            </PublicRouteGuard>
        ),
        path: locale => getMedicalTourismResultPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <ViewItinerary />
            </PublicRouteGuard>
        ),
        path: locale => getMyItineraryViewPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <RefundRules />
            </PublicRouteGuard>
        ),
        path: locale => getRefundRulesPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <AboutUs />
            </PublicRouteGuard>
        ),
        path: locale => getAboutUsPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <ContactUs />
            </PublicRouteGuard>
        ),
        path: locale => getContactUsPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <SubmitComplaints />
            </PublicRouteGuard>
        ),
        path: locale => getSubmitComplaintsPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <EventRegistration />
            </PublicRouteGuard>
        ),
        path: locale => getEventPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Location />
            </PublicRouteGuard>
        ),
        path: locale => getLocationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Miras />
            </PublicRouteGuard>
        ),
        path: locale => getMirasPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Rules />
            </PublicRouteGuard>
        ),
        path: locale => getRulesPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Information />
            </PublicRouteGuard>
        ),
        path: locale => getInformationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <LocationPoint />
            </PublicRouteGuard>
        ),
        path: locale => getLocationPointPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <FlightPassengers />
            </PublicRouteGuard>
        ),
        path: locale => getFlightPassengersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <IntFlightPassengers />
            </PublicRouteGuard>
        ),
        path: locale => getIntFlightPassengersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <HotelPassengers />
            </PublicRouteGuard>
        ),
        path: locale => getHotelPassengersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <IntHotelPassengers />
            </PublicRouteGuard>
        ),
        path: locale => getIntHotelPassengersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <BusPassengers />
            </PublicRouteGuard>
        ),
        path: locale => getBusPassengersPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <ConfirmInformation />
            </PublicRouteGuard>
        ),
        path: locale => getConfirmInformationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <Cart />
            </PublicRouteGuard>
        ),
        path: locale => getCartPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <PaymentResult />
            </PublicRouteGuard>
        ),
        path: locale => getPaymentResultPageUrl(locale),
    },

    {
        element: (
            <PublicRouteGuard>
                <AdminPanel />
            </PublicRouteGuard>
        ),
        path: locale => getAdminPanelPageUrl(locale),
        children: adminChildren,
    },
    {
        element: (
            <PublicRouteGuard>
                <FlightAvailabilityNotification />
            </PublicRouteGuard>
        ),
        path: locale => getFlightAvailabilityPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <FlightAutomaticReservation />
            </PublicRouteGuard>
        ),
        path: locale => getFlightAutomaticReservationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <FlightAutomaticReservationConfirm />
            </PublicRouteGuard>
        ),
        path: locale => getFlightAutomaticReservationConfirmPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <StudyAbroad />
            </PublicRouteGuard>
        ),
        path: locale => getStudyAbroadPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <WorkImmigration />
            </PublicRouteGuard>
        ),
        path: locale => getWorkImmigrationPageUrl(locale),
    },
    {
        element: (
            <PublicRouteGuard>
                <QRCode />
            </PublicRouteGuard>
        ),
        path: locale => getRedirectQRCodePageUrl(locale),
    },
];

const privateRoutes = [
    {
        element: (
            <PrivateRouteGuard>
                <UserPanel />
            </PrivateRouteGuard>
        ),
        path: locale => getUserPanelPageUrl(locale),
        children: userPanelChildren,
    },
];

export const businessRoute = {
    element: (
        <PublicRouteGuard>
            <BusinessCard />
        </PublicRouteGuard>
    ),
    path: () => getBusinessCardPageUrl(),
};

export const playgroundRoute = {
    element: (
        <PublicRouteGuard>
            <Playground />
        </PublicRouteGuard>
    ),
    path: () => getPlaygroundPageUrl(),
};

export const DefaultRoute = {
    element: (
        <PublicRouteGuard>
            <Playground />
        </PublicRouteGuard>
    ),
    path: () => getDefaultUrl(),
};

export const allRoutes = [...publicRoutes, ...privateRoutes];

export const headerPublicRoutes = t => [
    {
        label: "خرید بلیط",
        path: locale => getDomesticFlightPageUrl(locale),
    },
    {
        label: "رزرو هتل",
        path: locale => getHotelPageUrl(locale),
    },
    {
        label: t("contact-us"),
        path: locale => getContactUsPageUrl(locale),
    },
    {
        label: t("about-us"),
        path: locale => getAboutUsPageUrl(locale),
    },
    {
        label: t("Policies"),
        path: locale => getRulesPageUrl(locale),
    },
    {
        label: "ثبت شکایت",
        path: locale => getSubmitComplaintsPageUrl(locale),
    },
];
